import { ReactNode } from "react";

export function AccordionContent({ open, children }: { open: boolean, children: ReactNode }) {
    return <div className={`accordion ${open ? "open" : ""}`}>
        <div className={`accordion-content`}>
            <div className="accordion-inner">{children}</div>
        </div>
    </div>;
}
